export default "__VITE_ASSET__89b9e4e0__"